import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
const useJumpToSelectedGalleryPhoto = t0 => {
  const $ = _c(4);
  const {
    selectedPhotoIndex,
    isOpen
  } = t0;
  const galleryRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== selectedPhotoIndex) {
    t1 = () => {
      if (isOpen && galleryRef.current && selectedPhotoIndex > 0) {
        const targetElement = galleryRef.current.children[selectedPhotoIndex];
        setTimeout(() => {
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }, 200);
      }
    };
    t2 = [selectedPhotoIndex, isOpen];
    $[0] = isOpen;
    $[1] = selectedPhotoIndex;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return galleryRef;
};
export default useJumpToSelectedGalleryPhoto;